<template>
    <div class="line-wrap" v-if="showLine">
        <div class="logo"></div>
        <c-line :active-color="item.activeColor" v-for="(item, index) in lines" :key="'line' +index">
            <c-list @onSelectLine="changeLine" :active-color="item.activeColor" :list="item.list"></c-list>
        </c-line>
    </div>

    <div v-else class="line-wrap line-code clearBoth">
        <label>
            <input type="text" v-model="safeCode" placeholder="输入安全码">
        </label>
        <button class="code-btn normal-btn" @click="checkCode">确认</button>
    </div>
</template>

<script>
  import CLine from './components/line-conponent';
  import CList from './components/line-conponent/list';

  export default {
    name: "VLine",
    components: {
      CLine,
      CList
    },
    data() {
      return {
        lines: {
          one: {
            activeColor: '#E64520',
            list: [
              {
                title: '线路1',
                v: 46,
                selected: true
              },
              {
                title: '线路2',
                v: 46,
                selected: false
              },
              {
                title: '线路3',
                v: 46,
                selected: false
              },
              {
                title: '线路4',
                v: 46,
                selected: false
              },
              {
                title: '线路5',
                v: 46,
                selected: false
              },
              {
                title: '线路6',
                v: 46,
                selected: false
              },
              {
                title: '线路7',
                v: 46,
                selected: false
              },
            ]
          },
          two: {
            activeColor: '#29A8DB',
            list: [
              {
                title: '线路1',
                v: 46,
                selected: true
              },
              {
                title: '线路2',
                v: 46,
                selected: false
              },
              {
                title: '线路3',
                v: 46,
                selected: false
              },
              {
                title: '线路4',
                v: 46,
                selected: false
              },
              {
                title: '线路5',
                v: 46,
                selected: false
              },
              {
                title: '线路6',
                v: 46,
                selected: false
              },
              {
                title: '线路7',
                v: 46,
                selected: false
              },
            ]
          }
        },
        safeCode: '',
        showLine: false
      }
    },
    methods: {
      changeLine (item) {
        console.log(item)
      },

      getLineSpeed () {
      },

      checkCode () {
        this.$validate('safeCode', this.safeCode).then(res => {
          if (res) {
            this.showLine = true;

            /* 请求每个路线的速度 */
          } else {
            alert('安全码格式错误');
          }
        }).catch(err => {
          alert(err);
        })
      }
    }
  }
</script>


<style>
    body>>>.app_wrap{
        background-color: orangered;
    }
</style>

<style lang="stylus">
    html, body {
        height 100%
    }
    input::-webkit-input-placeholder{
        color: #999;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color: #999;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color: #999;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
        color: #999;
    }
</style>
<style scoped lang="stylus">
    .line-wrap {
        top 50%
        left 50%
        width 1000px
        position absolute
        transform translate(-50%, -50%)
        .logo {
            width 185px
            height 60px
            background url("images/logo.jpg") no-repeat center center
            background-size contain
        }
        .line {

        }
    }
    .line-code{
        width 640px
        padding-bottom 160px
        label{
            float left
            width 530px
            height 36px
            display block
            box-shadow 0 0 1px rgba(0,0,0,0.2), 0 0 10px rgba(0, 0, 0, 0.2)
            input{
                color #fff
                width 100%
                height 100%
                border none
                padding 0 8px
                display block
                box-sizing border-box
                letter-spacing 2px
                background-color rgba(0, 0, 0, 0.4)
            }
        }
        .code-btn{
            color #fff
            width 100px
            height 36px
            float right
            font-size 14px
            background-color #3385ff
            box-shadow 0 0 1px rgba(0,0,0,0.2), 0 0 10px rgba(0, 0, 0, 0.2)
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/line/index.vue